export enum TreatmentOptions {
  HORMONAL_CREAM_OR_GEL = "hormonalCreamOrGel",
  ESTROGEN_PATCH = "estrogenPatch",
  PILLS_OR_TABLETS = "pillsOrTablets",
  OTHER = "other",
}
